import {ISkill, Skill} from '../../app/model/skill';

export const skillsArray: ISkill[] =
  [
    {
      'name': 'Self Improvement',
      'nameID': 'SelfImprovementSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': false,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 3,
      'yPos': 2
    },
    {
      'name': 'Advanced Baking',
      'nameID': 'AdvancedBakingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Advanced Cooking',
      'nameID': 'AdvancedCookingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Advanced Masonry',
      'nameID': 'AdvancedMasonrySkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 1,
      'yPos': 2
    },
    {
      'name': 'Advanced Smelting',
      'nameID': 'AdvancedSmeltingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 2,
      'yPos': 2
    },
    {
      'name': 'Baking',
      'nameID': 'BakingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 6,
      'yPos': 2
    },
    {
      'name': 'Basic Engineering',
      'nameID': 'BasicEngineeringSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Blacksmith',
      'nameID': 'BlacksmithSkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 11
    },
    {
      'name': 'Butchery',
      'nameID': 'ButcherySkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 7,
      'yPos': 2
    },
    {
      'name': 'Campfire Cooking',
      'nameID': 'CampfireCookingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 4,
      'yPos': 0
    },
    {
      'name': 'Carpentry',
      'nameID': 'CarpentrySkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 0,
      'yPos': 4
    },
    {
      'name': 'Composites',
      'nameID': 'CompositesSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Cooking',
      'nameID': 'CookingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 0,
      'yPos': 3
    },
    {
      'name': 'Cutting Edge Cooking',
      'nameID': 'CuttingEdgeCookingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Electronics',
      'nameID': 'ElectronicsSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 1,
      'yPos': 3
    },
    {
      'name': 'Farming',
      'nameID': 'FarmingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 2,
      'yPos': 3
    },
    {
      'name': 'Fertilizers',
      'nameID': 'FertilizersSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Gathering',
      'nameID': 'GatheringSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': false,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 3,
      'yPos': 1
    },
    {
      'name': 'Glassworking',
      'nameID': 'GlassworkingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Hunting',
      'nameID': 'HuntingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': false,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 3,
      'yPos': 3
    },
    {
      'name': 'Industry',
      'nameID': 'IndustrySkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Logging',
      'nameID': 'LoggingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': false,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 4,
      'yPos': 3
    },
    {
      'name': 'Masonry',
      'nameID': 'MasonrySkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Mechanics',
      'nameID': 'MechanicsSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Milling',
      'nameID': 'MillingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 4,
      'yPos': 1
    },
    {
      'name': 'Mining',
      'nameID': 'MiningSkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': true,
      'lavishWorkspace': false,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 5,
      'yPos': 3
    },
    {
      'name': 'Oil Drilling',
      'nameID': 'OilDrillingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Painting',
      'nameID': 'PaintingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 15
    },
    {
      'name': 'Paper Milling',
      'nameID': 'PaperMillingSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 1,
      'yPos': 0
    },
    {
      'name': 'Pottery',
      'nameID': 'PotterySkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 7,
      'yPos': 1
    },
    {
      'name': 'Smelting',
      'nameID': 'SmeltingSkill',
      'basicUpgrade': false,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 6,
      'yPos': 3
    },
    {
      'name': 'Shipwright',
      'nameID': 'ShipwrightSkill',
      'basicUpgrade': true,
      'advancedUpgrade': true,
      'modernUpgrade': false,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Tailoring',
      'nameID': 'TailoringSkill',
      'basicUpgrade': true,
      'advancedUpgrade': false,
      'modernUpgrade': true,
      'lavishWorkspace': true,
      'imageFile': 'skill-icons-sprite.webp',
      'xPos': 4,
      'yPos': 2
    }
  ];

export const skills: Map<string, Skill> = new Map(skillsArray.map(
  skill => [skill.nameID, new Skill(skill)]
));
